import React from 'react';

import { Stack, Typography } from '@gogame/components';

import { COLUMN_KEY } from 'scenes/Gallery/GalleryPage/Creatives/CreativesDataTable/constants';

const IdColumn = ({ value, row }) => {
  return (
    <Stack>
      {value}
      <Typography variant={'caption'} color={'textSecondary'}>
        {row[COLUMN_KEY]}
      </Typography>
    </Stack>
  );
};

export default IdColumn;
